<div class="container">
    <div class="title">{{ 'Auth.form.resetPassword' | translate }}</div>

    <form [formGroup]="forgotPasswordForm" (ngSubmit)="handleSubmit()" class="form">
        <!-- Email Input -->
        <div class="input-group">
            <span class="label">{{ 'Auth.form.emailInput' | translate }}</span>
            <div class="input-wrapper">
                <input type="email" formControlName="email" [placeholder]="'Auth.form.emailInput' | translate"
                    class="input" [class.error]="isFieldInvalid('email')">
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('email')">
                {{ getErrorMessage('email') }}
            </div>
        </div>

        <!-- Send Code Button -->
        <button type="button" [disabled]="isSubmitting || countdown > 0" (click)="handleSendCode()" class="submit-btn">
            {{ countdown > 0 ? countdown + 's' : ('Auth.form.sendCode' | translate) }}
        </button>


        <!-- Verification Code Input -->
        <div class="input-group" *ngIf="isCodeSent">
            <span class="label">{{ 'Auth.form.verificationCode' | translate }}</span>
            <div class="input-wrapper">
                <input type="number" formControlName="code" [placeholder]="'Auth.form.verificationCode' | translate"
                    [class.error]="isFieldInvalid('code')">
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('code')">
                {{ getErrorMessage('code') }}
            </div>
        </div>

        <!-- New Password Input -->
        <div class="input-group" *ngIf="isCodeSent">
            <div>
                <span class="label">{{ 'Auth.form.passwordInput' | translate }}</span>
                <div class="input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" formControlName="newPassword"
                        [placeholder]="'Auth.form.newPassword' | translate"
                        [class.error]="isFieldInvalid('newPassword')">
                    <button type="button" class="toggle-password" (click)="togglePassword('newPassword')">
                        <app-eye></app-eye>
                    </button>
                </div>
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('newPassword')">
                {{ getErrorMessage('newPassword') }}
            </div>
        </div>


        <!-- Confirm Password Input -->
        <div class="input-group" *ngIf="isCodeSent">
            <div>
                <span class="label">{{ 'Auth.form.confirmPassword' | translate }}</span>
                <div class="input-wrapper">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                        [placeholder]="'Auth.form.confirmPassword' | translate"
                        [class.error]="isFieldInvalid('confirmPassword')">
                    <button type="button" class="toggle-password" (click)="togglePassword('confirmPassword')">
                        <app-eye></app-eye>
                    </button>
                </div>
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('confirmPassword')">
                {{ getErrorMessage('confirmPassword') }}
            </div>
        </div>

        <!-- Submit Button -->
        <button *ngIf="isCodeSent" type="submit" [disabled]="isSubmitting || !forgotPasswordForm.valid"
            class="submit-btn">
            {{ 'Auth.form.resetPassword' | translate }}
        </button>


    </form>
    <a routerLink="/users/login" class="link"> {{ 'Auth.form.backToLogin' | translate }}</a>
</div>